export const isProductStringAttribute = (
	attribute?: unknown,
): attribute is Queries.CommerceToolsAttributes_CommerceToolsProductAttributeString_Fragment => {
	return Boolean(
		attribute &&
			typeof attribute === "object" &&
			"__typename" in attribute &&
			attribute.__typename === "CommerceToolsProductAttributeString",
	);
};
export const isProductBooleanAttribute = (
	attribute?: unknown,
): attribute is Queries.CommerceToolsAttributes_CommerceToolsProductAttributeBoolean_Fragment => {
	return Boolean(
		attribute &&
			typeof attribute === "object" &&
			"__typename" in attribute &&
			attribute.__typename === "CommerceToolsProductAttributeBoolean",
	);
};

export const isProductFloatAttribute = (
	attribute?: unknown,
): attribute is Queries.CommerceToolsAttributes_CommerceToolsProductAttributeFloat_Fragment => {
	return Boolean(
		attribute &&
			typeof attribute === "object" &&
			"__typename" in attribute &&
			attribute.__typename === "CommerceToolsProductAttributeFloat",
	);
};

export const isProductStringArrayAttribute = (
	attribute?: unknown,
): attribute is Queries.CommerceToolsAttributes_CommerceToolsProductAttributeStringArray_Fragment => {
	return Boolean(
		attribute &&
			typeof attribute === "object" &&
			"__typename" in attribute &&
			attribute.__typename === "CommerceToolsProductAttributeStringArray",
	);
};

export const isProductObjectAttribute = (
	attribute?: unknown,
): attribute is Queries.CommerceToolsAttributes_CommerceToolsProductAttributeObject_Fragment => {
	return Boolean(
		attribute &&
			typeof attribute === "object" &&
			"__typename" in attribute &&
			attribute.__typename === "CommerceToolsProductAttributeObject",
	);
};

export const isValidStringAttribute = (obj: {
	stringValue?: string | null;
}): obj is { stringValue: string } => typeof obj.stringValue === "string";
